export const GOOGLE_EVENTS = {
  // Stage 1: Awareness
  VIEW_HOMEPAGE: 'view_homepage',
  SCROLL_DEPTH: 'scroll_depth',
  CTA_CLICK: 'cta_click',

  // Stage 2: Authentication
  SIGN_UP_START: 'sign_up_start',
  SIGN_UP_COMPLETE: 'sign_up_complete',
  LOGIN_START: 'login_start',
  LOGIN_COMPLETE: 'login_complete',
  MAGIC_LINK_REQUESTED: 'magic_link_requested',
  MAGIC_LINK_VERIFIED: 'magic_link_verified',
  PASSWORD_RESET_REQUESTED: 'password_reset_requested',
  AUTH_ERROR: 'auth_error',

  // Stage 3: Onboarding
  ONBOARDING_START: 'onboarding_start',
  ONBOARDING_STEP: 'onboarding_step',
  PHOTO_UPLOADED: 'photo_uploaded',
  CHILD_NAME_ENTERED: 'child_name_entered',
  EMAIL_CAPTURED: 'email_captured',
  TEMPLATE_SELECTED: 'template_selected',
  ONBOARDING_COMPLETE: 'onboarding_complete',
  ONBOARDING_ABANDONED: 'onboarding_abandoned',

  // Stage 4: Browsing
  VIEW_ITEM_LIST: 'view_item_list',
  SELECT_ITEM: 'select_item',
  VIEW_ITEM: 'view_item',
  FILTER_APPLIED: 'filter_applied',
  SEARCH_PERFORMED: 'search_performed',

  // Stage 5: Personalization
  BEGIN_PERSONALIZATION: 'begin_personalization',
  CHARACTER_SELECTED: 'character_selected',
  PERSONALIZATION_STEP: 'personalization_step',
  PREVIEW_GENERATED: 'preview_generated',
  PERSONALIZATION_COMPLETE: 'personalization_complete',
  PERSONALIZATION_ABANDONED: 'personalization_abandoned',

  // Stage 6: Cart & Checkout
  ADD_TO_CART: 'add_to_cart',
  VIEW_CART: 'view_cart',
  REMOVE_FROM_CART: 'remove_from_cart',
  BEGIN_CHECKOUT: 'begin_checkout',
  CHECKOUT_REDIRECT: 'checkout_redirect',

  // Stage 7: Story Creation
  STORY_CREATION_START: 'story_creation_start',
  CHARACTER_ADDED: 'character_added',
  PLOT_GENERATED: 'plot_generated',
  PLOT_REFINED: 'plot_refined',
  STYLE_SELECTED: 'style_selected',
  STORY_SUBMITTED: 'story_submitted',
  STORY_GENERATION_COMPLETE: 'story_generation_complete',
  STORY_CREATION_ABANDONED: 'story_creation_abandoned',

  // Stage 8: Library
  VIEW_LIBRARY: 'view_library',
  VIEW_STORY: 'view_story',
  STORY_EDITED: 'story_edited',
  UNLOCK_PROMPT_SHOWN: 'unlock_prompt_shown',
  UNLOCK_INITIATED: 'unlock_initiated',
  SHARE_STORY: 'share_story',
  PRINT_INITIATED: 'print_initiated',

  // Stage 9: Profile
  PROFILE_CREATED: 'profile_created',
  PROFILE_UPDATED: 'profile_updated',
  CHARACTER_CREATED: 'character_created',
  AVATAR_GENERATED: 'avatar_generated',
} as const

export const META_EVENTS = {
  PAGE_VIEW: 'PageView',
  VIEW_CONTENT: 'ViewContent',
  CUSTOMIZE_PRODUCT: 'CustomizeProduct',
  ADD_TO_CART: 'AddToCart',
  INITIATE_CHECKOUT: 'InitiateCheckout',
  COMPLETE_REGISTRATION: 'CompleteRegistration',
  LEAD: 'Lead',
  PURCHASE: 'Purchase',
  SEARCH: 'Search',
} as const


export type GoogleEventName = (typeof GOOGLE_EVENTS)[keyof typeof GOOGLE_EVENTS]
export type MetaEventName = (typeof META_EVENTS)[keyof typeof META_EVENTS]
